import type { FileUpload } from 'graphql-upload/GraphQLUpload.js'
import GraphQLUpload from 'graphql-upload/GraphQLUpload.js'
import { Field, ID, InputType, Int, ObjectType } from 'type-graphql'

import { ApprovalLineItem } from '@things-factory/organization'
import { ObjectRef, ScalarObject } from '@things-factory/shell'

import { DataItemPatch } from './data-item-type.js'
import {
  DataSet,
  DataSetEntryType,
  DataSetMonitorType,
  DataSetReportType,
  DataSetSummaryPeriodType
} from './data-set.js'

@InputType()
export class NewDataSet {
  @Field({
    description:
      'The unique name identifier for the dataset. This field is used for dataset identification and must be unique within the domain.'
  })
  name: string

  @Field({ nullable: true })
  description?: string

  @Field({ nullable: true, description: 'A tag name of data to be published when a data sample created' })
  tag?: string

  @Field(type => ObjectRef, { nullable: true })
  dataKeySet?: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  entryRole?: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  supervisoryRole?: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  resolverRole?: ObjectRef

  @Field(type => ScalarObject, { nullable: true })
  reviewApprovalLine?: ApprovalLineItem[]

  @Field(type => ScalarObject, { nullable: true })
  outlierApprovalLine?: ApprovalLineItem[]

  @Field(type => ObjectRef, { nullable: true })
  normalScenario?: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  outlierScenario?: ObjectRef

  @Field({ nullable: true })
  active?: boolean

  @Field({ nullable: true })
  type?: 'manual' | 'automatic' | string

  @Field({ nullable: true })
  useCase?: string

  @Field(type => ScalarObject, { nullable: true })
  partitionKeys?: { [key: string]: any }

  @Field(type => [DataItemPatch], { nullable: true })
  dataItems?: DataItemPatch[]

  @Field({ nullable: true })
  schedule?: string

  @Field({ nullable: true })
  timezone?: string

  @Field({ nullable: true })
  requiresReview?: boolean

  @Field({ nullable: true })
  entryType?: DataSetEntryType

  @Field({ nullable: true })
  entryView?: string

  @Field({ nullable: true })
  monitorType?: DataSetMonitorType

  @Field({ nullable: true })
  monitorView?: string

  @Field({ nullable: true })
  reportType?: DataSetReportType

  @Field({ nullable: true })
  reportView?: string

  @Field(type => GraphQLUpload, { nullable: true })
  reportTemplate?: FileUpload

  @Field({ nullable: true })
  summaryPeriod?: DataSetSummaryPeriodType

  @Field({
    nullable: true,
    description: 'The maximum allowed time limit (in seconds) for completing the data entry operation'
  })
  timeLimit?: number
}

@InputType()
export class DataSetPatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true })
  description?: string

  @Field({ nullable: true, description: 'A tag name of data to be published when a data sample created' })
  tag?: string

  @Field(type => ObjectRef, { nullable: true })
  dataKeySet?: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  supervisoryRole?: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  entryRole?: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  resolverRole?: ObjectRef

  @Field(type => ScalarObject, { nullable: true })
  reviewApprovalLine?: ApprovalLineItem[]

  @Field(type => ScalarObject, { nullable: true })
  outlierApprovalLine?: ApprovalLineItem[]

  @Field(type => ObjectRef, { nullable: true })
  normalScenario?: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  outlierScenario?: ObjectRef

  @Field({ nullable: true })
  active?: boolean

  @Field({ nullable: true })
  type?: 'manual' | 'automatic' | string

  @Field({ nullable: true })
  useCase?: string

  @Field(type => ScalarObject, { nullable: true })
  partitionKeys?: { [key: string]: any }

  @Field(type => [DataItemPatch], { nullable: true })
  dataItems?: DataItemPatch[]

  @Field({ nullable: true })
  schedule?: string

  @Field({ nullable: true })
  timezone?: string

  @Field({ nullable: true })
  requiresReview?: boolean

  @Field({ nullable: true })
  entryType?: DataSetEntryType

  @Field({ nullable: true })
  entryView?: string

  @Field({ nullable: true })
  monitorType?: DataSetMonitorType

  @Field({ nullable: true })
  monitorView?: string

  @Field({ nullable: true })
  reportType?: DataSetReportType

  @Field({ nullable: true })
  reportView?: string

  @Field(type => GraphQLUpload, { nullable: true })
  reportTemplate?: FileUpload

  @Field({ nullable: true })
  summaryPeriod?: DataSetSummaryPeriodType

  @Field({
    nullable: true,
    description: 'The maximum allowed time limit (in seconds) for completing the data entry operation'
  })
  timeLimit?: number

  @Field()
  cuFlag: string
}

@ObjectType()
export class DataSetList {
  @Field(type => [DataSet])
  items: DataSet[]

  @Field(type => Int)
  total: number
}
